export const convertDate = (date_from, date_to) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    let dateFrom = new Date(date_from);
    let dateTo = new Date(date_to);
    dateFrom = [pad(date_from.getDate()), pad(date_from.getMonth() + 1), date_from.getFullYear()].join('/');
    dateTo = [pad(date_to.getDate()), pad(date_to.getMonth() + 1), date_to.getFullYear()].join('/');
    return { dateFrom, dateTo };
};